import React from "react"
import { Input, Button } from "antd"
import { SearchOutlined, PlusOutlined } from "@ant-design/icons"
import { translations } from "../../utils/Translation/staticTranslation"
import "./Contacts.css"

const ContactFilters = ({
  searchValue,
  onSearchChange,
  onCreateContactList,
  readOnly = false,
}) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.contactsPage || {}
  const readOnlyHint = translations[lang]?.Referrals?.read_only_hint

  return (
    <div className="contact-filters-container">
      <Input
        placeholder={t?.search_contacts || "Search by name"}
        prefix={<SearchOutlined className="contact-search-icon" />}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        className="contact-search-input"
      />

      <div className="contact-filters-right">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateContactList}
          disabled={readOnly}
          title={readOnly ? readOnlyHint : undefined}
          className="contact-create-button"
        >
          {t?.create_contact_group || "Create Contact Group"}
        </Button>
      </div>
    </div>
  )
}

export default ContactFilters
